import Box from "@material-ui/core/Box";
import { makeStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";
import React, { useState } from "react";
import CustomDateRangePicker from "./CustomDateRangePicker";
import DateRange, { stringifyDateRange } from "./DateRange.model";
import RequestsTable from "./RequestsTable";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    "& > * + *": {
      marginBottom: theme.spacing(3),
    },
  },
  subHeading: {
    display: "block",
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: "1.5rem",
    marginBottom: theme.spacing(1),
  },
}));

interface AdminRequestsProps {
  className?: string;
}

const AdminRequests: React.FC<AdminRequestsProps> = ({ className }) => {
  const [dateRange, setDateRange] = useState<DateRange<string> | null>(null);
  const classes = useStyles();

  const handleDateRangeChange = (range: DateRange<Date> | null) => {
    setDateRange(range && stringifyDateRange(range));
  };

  return (
    <Box className={clsx([className, classes.container])}>
      <div className={classes.subHeading}>Requests</div>
      <CustomDateRangePicker nullable onChange={handleDateRangeChange} />
      <RequestsTable dateRange={dateRange} />
    </Box>
  );
};

export default AdminRequests;
